"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../../constants/colors");
var colorHelpers_1 = __importDefault(require("../../utils/colorHelpers"));
exports.Options = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 15px;\n  line-height: 14px;\n  padding: ", ";\n  position: relative;\n\n   &:hover {\n    background-color: ", ";\n  }\n"], ["\n  background-color: ",
    ";\n  color: ", ";\n  font-size: 15px;\n  line-height: 14px;\n  padding: ", ";\n  position: relative;\n\n   &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var selectOptionsBackgroundColor = _a.selectOptionsBackgroundColor, selectOptionsSelectedBackgroundColor = _a.selectOptionsSelectedBackgroundColor, theme = _a.theme, isSelected = _a.isSelected, highlight = _a.highlight;
    return isSelected || highlight ? colorHelpers_1.default(selectOptionsSelectedBackgroundColor, theme, colors_1.colors.GREY_150) : 'transparent';
}, function (_a) {
    var selectOptionsColor = _a.selectOptionsColor, theme = _a.theme;
    return colorHelpers_1.default(selectOptionsColor, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var optionsPadding = _a.optionsPadding;
    return optionsPadding ? optionsPadding : '16px';
}, function (_a) {
    var selectOptionsBackgroundColorHover = _a.selectOptionsBackgroundColorHover, theme = _a.theme, isSelected = _a.isSelected, highlight = _a.highlight;
    return colorHelpers_1.default(selectOptionsBackgroundColorHover, theme, colors_1.colors.GREY_150);
});
var templateObject_1;
//# sourceMappingURL=Options.js.map